import { useEffect } from 'react';
import { useLocation } from "@/lib/router-compat";

/**
 * Scrolls window to top on route change
 * Excludes hash-based navigation (anchor links)
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll if navigating to an anchor (hash link)
    if (!hash) {
      // Use setTimeout to ensure DOM has updated with new content
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant' // Instant scroll, no animation
        });
      }, 0);
    }
  }, [pathname, hash]);

  return null;
}
